import axios from 'axios'

export default {
	// ----------------------
	// ログインして設定を取得する
	getSoraSetting(url, id, key, username) {
		return axios.post(url, JSON.stringify({
			"id": id,
			"key": key,
			"user_name": username
		}));
	},

	// ----------------------
	// ログアウトする
	async setSoraLogout(soraData) {
		if (!soraData) return;
		return await axios.post(soraData.setting.url + "/logout", JSON.stringify({
			"user_id": soraData.sora.user_id
		}), {
			headers: {
				'Content-Type': 'text/plain'
			}
		});

	},

	// ----------------------
	// waitのポーリング
	async getSoraWait(soraData) {
		if (!soraData.setting || !soraData.sora) {
			return { "type": "dataerror", "message": "url not find" };
		}

		let url = soraData.setting.url + "/wait";
		let userid = soraData.sora.user_id;

		try {
			// waitを取得
			let d = await axios.post(url, JSON.stringify({
				"user_id": userid
			}), {
				headers: {
					'Content-Type': 'text/plain'
				},
				timeout: 30000
			});

			if (!d.data) {
				return { "type": "error", "message": "nothing data", "data": d.data }
			}

			// callの場合は強制終了し次のシーケンス
			if (d.data.command == "Call") {
				return { "type": "call", "message": "goto room", "data": d.data }
			}

			if (d.data.login == false) {
				return { "type": "logout", "message": "logout", "data": d.data }
			}

			let isUpdate = false;

			// ユーザー情報があったらアップデート
			if (d.data.users) {

				let usersList = [];
				for (let u in d.data.users) {
					// 自分を除外する
					if (d.data.user_id != u) {
						let usr = d.data.users[u];
						if (usr.status != "Idle") continue;
						let names = usr.name.split("-");
						usr.modelType = names.shift();
						usr.name = names.join("-");
						usersList.push(usr);
					}
					// usersList.push(d.data.users[u]);
				}

				let isSameU = soraData.users.length == usersList.length;
				if (isSameU) {
					for (let i in soraData.users) {
						if (!d.data.users[soraData.users[i].user_id]) {
							isSameU = false;
						}
					}
				}
				// 前と違ったらupdate
				if (!isSameU) {
					isUpdate = true;
					soraData.users = usersList;
				}

				soraData.sora.users = d.data.users;
			}


			// ルーム情報があったらアップデート
			if (d.data.rooms) {

				let roomsList = [];
				for (let r in d.data.rooms) {
					roomsList.push(d.data.rooms[r]);
				}

				// 過去のデータとあわせてupdateがあったかどうか判定
				let isSame = soraData.rooms.length == roomsList.length;
				if (isSame) {
					for (let i in soraData.rooms) {
						if (!d.data.rooms[soraData.rooms[i].room_id]) {
							isSame = false;
						}
					}
				}
				// 前と違ったらupdate
				if (!isSame) {
					isUpdate = true;
					soraData.rooms = roomsList;
				}

				soraData.sora.rooms = d.data.rooms;
			}

			// 情報がアップデートされたら
			if (isUpdate) {
				return { "type": "update", "data": soraData };
			} else {
				return { "type": "noupdate", "data": soraData };
			}

		} catch (e) {
			return {
				"type": "unknown",
				"message": "unknown",
				"data": e
			}
		}
	},

	// ----------------------
	// 呼び出し先を取得
	async getSoraCall(soraData, targetId) {
		if (!soraData.setting || !soraData.sora) {
			return { "type": "dataerror", "message": "url not find" };
		}

		let url = soraData.setting.url + "/call";
		let userid = soraData.sora.user_id;

		try {
			// callを取得
			let d = await axios.post(url, JSON.stringify({
				'user_id': userid,
				'callees': [targetId]
			}), {
				headers: {
					'Content-Type': 'text/plain'
				}
			});
			if (d.data && !d.data.success) {
				return { "type": "servererror", "message": "not find" };
			}
			return d;

		} catch (e) {
			return {
				"type": "unknown",
				"message": "unknown",
				"data": e
			}
		}
	},

	// ----------------------
	// PUSH通知でチャンネル全員に対して配信
	async setSoraPushChannel(url, sendData) {
		return axios.post(url, JSON.stringify(sendData), {
			headers: {
				'x-sora-target': 'Sora_20160711.PushChannel'
			}
		});
	},

	// ----------------------
	// PUSH通知で一人だけに絞って配信
	async setSoraPushClient(url, sendData) {
		return axios.post(url, JSON.stringify(sendData), {
			headers: {
				'x-sora-target': 'Sora_20160711.PushClient'
			}
		});
	},

	// ----------------------
	// PUSH通知で1つのコネクションだけに絞って配信
	async setSoraPushConnection(url, sendData) {
		return axios.post(url, JSON.stringify(sendData), {
			headers: {
				'x-sora-target': 'Sora_20160711.PushConnection'
			}
		});
	},

	// ----------------------
	// SORAからクライアントから切断する
	async setSoraDisconnectClient(url, sendData) {
		return axios.post(url, JSON.stringify(sendData), {
			headers: {
				'x-sora-target': 'Sora_20151104.DisconnectClient'
			}
		});
	},
	// ----------------------
	// SORAからコネクションを切断する
	async setSoraDisconnectConnection(url, sendData) {
		return axios.post(url, JSON.stringify(sendData), {
			headers: {
				'x-sora-target': 'Sora_20151104.DisconnectConnection'
			}
		});
	},

	// ----------------------
	// FileをCMSに登録する
	async sendFileToCms(file, accessCode, clientId) {
		if (!file) throw ({ "message": "file not select" });
		if (!process.env.HOLO_GYROEYE_FILELINK_LOGINURL) throw ({ "message": "Filelink Login URL not set" });
		if (!process.env.HOLO_GYROEYE_FILELINK_LOGOUTURL) throw ({ "message": "Filelink Logout URL not set" });
		if (!process.env.HOLO_GYROEYE_FILELINK_SAVEURL) throw ({ "message": "Filelink Save URL not set" });
		if (!accessCode) throw ({ "message": "Access code not set" });
		if (!clientId) throw ({ "message": "Client id not set" });
		try {
			var params = new URLSearchParams();
			params.append('access_code', accessCode);
			params.append('client_id', clientId);

			// login
			let loginData = await axios.post(process.env.HOLO_GYROEYE_FILELINK_LOGINURL, params);
			// fileを保存
			var formData = new FormData();
			formData.append("file", file);
			let sendData = await axios.post(process.env.HOLO_GYROEYE_FILELINK_SAVEURL, formData, {
				headers: {
					"Auth-Token": loginData.data.data.access_token
				}
			});
			let logoutData = await axios.post(process.env.HOLO_GYROEYE_FILELINK_LOGOUTURL, null, {
				headers: {
					"Auth-Token": loginData.data.data.access_token
				}
			});

			return sendData.data.data.url;

		} catch (e) {
			throw (e);
		}
	},

	// ----------------------
	// FileをCMSがら呼び出す
	async getFileUrlFronCms(url, accessCode, clientId) {
		if (!url) throw ({ "message": "url not select" });
		if (!process.env.HOLO_GYROEYE_FILELINK_LOGINURL) throw ({ "message": "Filelink Login URL not set" });
		if (!process.env.HOLO_GYROEYE_FILELINK_LOGOUTURL) throw ({ "message": "Filelink Logout URL not set" });
		if (!process.env.HOLO_GYROEYE_FILELINK_TOKENURL) throw ({ "message": "Filelink Token URL not set" });
		if (!accessCode) throw ({ "message": "Access code not set" });
		if (!clientId) throw ({ "message": "Client id not set" });
		try {
			var params = new URLSearchParams();
			params.append('access_code', accessCode);
			params.append('client_id', clientId);

			// login
			let loginData = await axios.post(process.env.HOLO_GYROEYE_FILELINK_LOGINURL, params);
			// tokenを取得
			let sendData = await axios.post(process.env.HOLO_GYROEYE_FILELINK_TOKENURL, null, {
				headers: {
					"Auth-Token": loginData.data.data.access_token
				}
			});
			let urlpath = url + "&ot_token=" + sendData.data.data.ot_token;

			// 30秒後にログアウトする
			setTimeout(async () => {
				let logoutData = await axios.post(process.env.HOLO_GYROEYE_FILELINK_LOGOUTURL, null, {
					headers: {
						"Auth-Token": loginData.data.data.access_token
					}
				});
			}, 30000)


			return { "url": urlpath, "authToken": loginData.data.data.access_token };
		} catch (e) {
			throw (e);
		}
	},

	// ----------------------
	// CMSからログアウトする
	async getCmsLogout(accessToken) {
		try {
			let logoutData = await axios.post(process.env.HOLO_GYROEYE_FILELINK_LOGOUTURL, null, {
				headers: {
					"Auth-Token": accessToken
				}
			});
			return true;
		} catch (e) {
			throw (e);
		}
	},


}


// WEBPACK FOOTER //
// ./src/api/serveraccess.js